import { useQuery } from "@tanstack/react-query";
import VerticalNav from "components/admin/navigation/verticalNav";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { getHotelStatic } from "src/api/hotelApi";
import AdminTopNavbar from "src/components/admin/navigation/adminTopNav";
import ScrollToButton from "src/components/button/scrollTo";
import { useAuth } from "src/contexts/AuthContext";
import { hotelAction } from "src/redux/actions";
import { propsBasicLayoutType } from "utils/proptypes";

const AdminLayout = (props: propsBasicLayoutType) => {
   const { children } = props

   const dispatch = useDispatch();
   const { isAdmin } = useAuth();

   const mainRef = useRef<HTMLDivElement>(null)

   const { data } = useQuery({
      queryKey: ['getHotelStatic'],
      queryFn: getHotelStatic,
      retry: false,
      staleTime: Infinity,
   });

   useEffect(() => {
      if (data?.data) {
         dispatch(hotelAction.setHotelStatic(data?.data));
      }
   }, [data?.data]);

   return (
      <div className="min-h-screen">
         {/* Navigation bar */}
         <AdminTopNavbar darkMode />

         <div className="flex relative space-x-0 min-h-full h-[calc(100vh-68px)] overflow-auto">
            {/* Veritical side bar */}
            {isAdmin && <VerticalNav />}

            {/* Main content */}
            <div
               ref={mainRef}
               className="relative flex-1 h-full min-h-full p-3.75 lg:p-7.5 bg-white overflow-x-hidden overflow-y-scroll"
            >
               {children}
               <ScrollToButton containerRef={mainRef} />
            </div>
         </div>
      </div>
   )
}

export default AdminLayout